import {
    LinearProgress,
    Typography,
} from "@mui/material";
import styled from "styled-components";

export const ProgressBarContainer: any = styled.div<{ }>`

`;

export const ProgressBar = styled(LinearProgress) <{ }>`

`;

const CustomProgressBar = (props: any) => {
    const {
        color = 'info', //"primary" | "secondary" | "error" | "info" | "success" | "warning" | "inherit"
        variant = "determinate", //'buffer' | 'determinate' | 'indeterminate' | 'query'
        progressTitle = "",
        valueAmount = 0,
        overAmount = 0,
        ...other
    } = props;
    let percentage = (valueAmount / overAmount) * 100;
    return (
        <ProgressBarContainer className={props?.className ?? ""}>
           <ProgressBar color={color} sx={{ height: 8, borderRadius: 10 }} variant={variant} value={isNaN(percentage) ? 0 : percentage} />
           <Typography variant="caption" gutterBottom>{`${valueAmount} / ${overAmount} ${progressTitle}`}</Typography>
        </ProgressBarContainer>
    );
}

export default CustomProgressBar;